// 抽屉式色板与选项按钮组（TextBeadModal / TextOverlayModal 共用）

function hexRgb(hex) {
  const n = parseInt(hex.replace('#', ''), 16)
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

function rgbToHue(r, g, b) {
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const d = max - min
  if (d === 0) return 0
  let h
  if (max === r) h = ((g - b) / d) % 6
  else if (max === g) h = (b - r) / d + 2
  else h = (r - g) / d + 4
  return (h * 60 + 360) % 360
}

// 每个色系只选 1 个代表色（深色用于边框 / 浅色用于背景），减少选择负担
export function pickByFamily(colors, mode) {
  const families = new Map()
  for (const c of colors) {
    const { r, g, b } = hexRgb(c.hex)
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    const sat = max === 0 ? 0 : (max - min) / max
    const luma = 0.299 * r + 0.587 * g + 0.114 * b
    let family
    if (sat < 0.15) {
      family = 'neutral'
    } else {
      const h = rgbToHue(r, g, b)
      family = `h${Math.floor(h / 30)}`
    }
    const prev = families.get(family)
    if (!prev || (mode === 'dark' ? luma < prev.luma : luma > prev.luma)) {
      families.set(family, { color: c, luma })
    }
  }
  return Array.from(families.values()).map((f) => f.color)
}

// 抽屉式色板（与图纸编辑的色板一致的体验）
export function SwatchPicker({ value, onChange, label, colors, maxHeight = 'max-h-28' }) {
  const current = colors.find((c) => c.id === value)
  return (
    <div>
      <label className="mb-1 flex items-center justify-between text-xs font-medium text-cocoa-light">
        <span>{label}</span>
        {current && (
          <span className="flex items-center gap-1 text-cocoa">
            <span
              className="inline-block h-3.5 w-3.5 rounded border border-black/10"
              style={{ backgroundColor: current.hex }}
            />
            {current.name}
          </span>
        )}
      </label>
      <div className={`flex flex-wrap gap-1 overflow-y-auto rounded-xl border border-lavender/30 bg-cream-50 p-2 ${maxHeight}`}>
        {colors.map((c) => (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            className={`h-7 w-7 rounded-md border-2 transition ${
              value === c.id
                ? 'border-blush scale-110 shadow-sm'
                : 'border-black/10 hover:scale-105'
            }`}
            style={{ backgroundColor: c.hex }}
            title={c.name}
          />
        ))}
      </div>
    </div>
  )
}

// 按钮组（替代下拉列表）
export function OptionGroup({ value, onChange, label, options }) {
  return (
    <div>
      <label className="mb-1 block text-xs font-medium text-cocoa-light">{label}</label>
      <div className="flex flex-wrap gap-1.5">
        {options.map((o) => (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={`rounded-lg border px-3 py-1.5 text-xs font-semibold transition ${
              value === o.value
                ? 'border-blush bg-blush text-white'
                : 'border-lavender/40 bg-white text-cocoa hover:border-blush'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  )
}

// 无级字号滑杆
export function SizeSlider({ label, value, onChange, min, max }) {
  return (
    <div>
      <label className="mb-1 flex items-center justify-between text-xs font-medium text-cocoa-light">
        <span>{label}</span>
        <span className="text-cocoa">{value} 豆</span>
      </label>
      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-blush"
      />
    </div>
  )
}
